'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _components = require('components');

var _auth = require('redux/modules/auth');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _Link = require('react-router/lib/Link');

var _Link2 = _interopRequireDefault(_Link);

var _TermsHint = require('./TermsHint');

var _TermsHint2 = _interopRequireDefault(_TermsHint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var TermsAcceptance = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    termsAccepted: state.auth.termsAccepted
  };
}, { acceptTerms: _auth.acceptTerms }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(TermsAcceptance, _Component);

  function TermsAcceptance() {
    (0, _classCallCheck3.default)(this, TermsAcceptance);
    return (0, _possibleConstructorReturn3.default)(this, (TermsAcceptance.__proto__ || (0, _getPrototypeOf2.default)(TermsAcceptance)).apply(this, arguments));
  }

  (0, _createClass3.default)(TermsAcceptance, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.acceptTerms(false);
    }
  }, {
    key: 'getTermsText',
    value: function getTermsText() {
      var t = this.props.t;


      return _react2.default.createElement(_reactI18next.Interpolate, {
        i18nKey: 'I agree to the {{privacyPolicy}}, {{termsOfService}} and {{cookiePolicy}} of this website.',
        privacyPolicy: _react2.default.createElement(
          _Link2.default,
          { target: '_blank', to: '/info/privacy-policy' },
          t('Privacy Policy')
        ),
        termsOfService: _react2.default.createElement(
          _Link2.default,
          { target: '_blank', to: '/info/terms-of-service' },
          t('Terms of Service')
        ),
        cookiePolicy: _react2.default.createElement(
          _Link2.default,
          { target: '_blank', to: '/info/cookie-policy' },
          t('Cookie Policy')
        )
      });
    }
  }, {
    key: 'toggleTerms',
    value: function toggleTerms(e) {
      this.props.acceptTerms(e.target.checked);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          termsAccepted = _props.termsAccepted,
          hintClassName = _props.hintClassName;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: className },
          _react2.default.createElement(
            'div',
            { className: 'margin-bottom-10' },
            _react2.default.createElement(_components.Checkbox, {
              small: true,
              checked: termsAccepted,
              onChange: this.toggleTerms,
              textAfter: this.getTermsText()
            })
          )
        ),
        _react2.default.createElement(_TermsHint2.default, { className: hintClassName })
      );
    }
  }]);
  return TermsAcceptance;
}(_react.Component), _class3.propTypes = {
  acceptTerms: _propTypes2.default.func,
  className: _propTypes2.default.string,
  hintClassName: _propTypes2.default.string,
  t: _propTypes2.default.func,
  termsAccepted: _propTypes2.default.bool
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'toggleTerms', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleTerms'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = TermsAcceptance;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/TermsAcceptance.js
// module id = 1953
// module chunks = 1